module.exports = __webpack_public_path__ + "static/media/gray_07.8b3cf215.jpg";